export class KydSmartphoneEnrolledOperatorEnrollmentSummaryModel {
  public operatorId: string;
  public operatorEnrollmentStatus: string;
}
